import { render, staticRenderFns } from "./FormInsert.vue?vue&type=template&id=696ed938"
import script from "./FormInsert.vue?vue&type=script&lang=js"
export * from "./FormInsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports